import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, $isFullScreen }) => css`
    align-items: flex-start;
    align-self: flex-end;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.16);
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 16px;
    justify-content: center;
    padding: 24px;
    position: fixed;
    width: 310px;
    top: ${!$isFullScreen ? '70px' : '140px'};
    margin-right: ${$isFullScreen && '20px'};
    z-index: ${theme.v2.layers.awaysOnTop};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 270px;
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `};
`;

export const Divider = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highMedium};
    height: 1px;
    width: 100%;
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `};
`;

export const CheckboxWrapper = styled.label`
    align-items: center;
    display: flex;
    gap: 8px;

    button {
      padding: 0;
    }

    svg {
      flex: 0 0 12px !important;
    }
`;

export const CheckboxDescription = styled.button`
${({ theme }) => css`
    all: unset;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    padding: 0;
    margin: 0;
    cursor: pointer;
  `}
`;

export const LinkWrapper = styled.div`
  ${({ theme }) => css`
    a {
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: underline !important;
    }
  `}
`;


export const GroupTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const BoldButton = styled.button`
  ${({ theme, $top }) => css`
    align-items: center;
    background: none;
    border: none;
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: flex-start;
    margin: 0;
    padding: 0;

    ${$top && css`
      margin-top: ${$top};
    `}

    svg { 
      width: 20px;
      height: 20px;
    }
  `}
`;
